import type React from "react";

import { Box } from "@mui/material";

import { AccordionSkeleton } from "./AccordionSkeleton";

interface AccordionListSkeletonProps {
  count?: number;
  dataTestId?: string;
}

export const AccordionListSkeleton: React.FC<AccordionListSkeletonProps> = ({ count = 8, dataTestId }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }} data-testid={dataTestId}>
      {Array.from({ length: count }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <AccordionSkeleton key={`accordion-skeleton-${index}`} index={index} />
      ))}
    </Box>
  );
};
